import React from 'react';
import Modal from "../../components/modal/modal";
import styles from './init-tipsModal.css'

const TaskInitModal = ({onClose,onConfirm,type}) => {
    return (
        <Modal
            title="温馨提示"
            onClose={onClose}
            >
            <div className={styles.content}>
                <p>确认要重做当前{type === 'task'? '任务' : '作业'}吗？</p>
            </div>

            <div className={styles.btn}>
                <span onClick={onClose}>取消</span>
                <span onClick={onConfirm}>确认</span>
            </div>
        </Modal>

    );
}

export default TaskInitModal;
